module.exports = __webpack_public_path__ + "static/media/1.d045a183.jpg";